import { connect } from 'react-redux';
import DeckFooter from '../components/DeckFooter.jsx';
import { toggleInfoConsole } from '../actions/ui';
import { getFolderByInviteId } from '../selectors';

const mapDispatchToProps = {toggleInfoConsole};

const mapStateToProps = (state) => {
  return {
    folderOptions: getFolderByInviteId(state).options || {}
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeckFooter);
